import React, { useCallback, useEffect, useState } from "react";

import { getAllShapefileSettings } from "services";

import { getShapefileRegions, useCancelAsyncOnUnmount } from "utils";

import { AdminHead, AdminSection, AdminTable, Col, MainPage, Row } from "components";

export const ShapefileSettings = () => {
  const [loading, setLoading] = useState(false);
  const [settings, setSettings] = useState(false);
  const signal = useCancelAsyncOnUnmount()();

  const loadShapefileSettings = useCallback(() => {
    setLoading(true);
    getShapefileRegions({ signal }).then((regionEnums) => {
      getAllShapefileSettings({
        signal,
      })
        .then((res) => {
          const updatedSettings = {
            invekos: [],
            managementTools: res.managementTools,
          };

          // makes the region more readable
          res.invekos.forEach((setting) => {
            updatedSettings.invekos.push({
              ...setting,
              region: regionEnums[setting.region],
            });
          });

          setSettings(updatedSettings);
        })
        .finally(() => {
          setLoading(false);
        });
    });
  }, [signal]); // eslint-disable-line

  useEffect(() => {
    loadShapefileSettings();
  }, [loadShapefileSettings]);

  return (
    <MainPage loading={loading} pageName={"admin"}>
      <AdminHead
        headline="Shapefile settings"
        description="Here you can view and edit the shapefile settings for individual federal states and farm management tools."
        link={"/farms/shapefiles"}
        tooltipText={"Back to shapefiles"}
      />
      <Row>
        <Col>
          <AdminTable
            dataSource={settings.invekos}
            config={{
              actions: [
                {
                  icon: "tabler/edit",
                  route: "/shapefile/updates/",
                  tooltip: "Edit settings for this region",
                },
              ],
              exclude: ["id"],
            }}
          />
        </Col>
      </Row>

      <AdminSection headline={"Farm management tool settings"} />
      <Row>
        <Col>
          <AdminTable
            dataSource={settings.managementTools}
            config={{
              actions: [
                {
                  icon: "tabler/edit",
                  route: "/shapefile/updates/",
                  tooltip: "Edit settings for this region",
                },
              ],
              exclude: ["id"],
            }}
          />
        </Col>
      </Row>
    </MainPage>
  );
};
